import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SxProps,
} from "@mui/material";
import React from "react";

type SelectProps<T> = {
  label: string;
  defaultValue?: string;
  value?: T | null;
  options?: { id: string | null; name: string | React.JSX.Element }[];
  onChange?: (value: T) => void;
  sx?: SxProps;
  noneLabel?: string;
  hideNone?: boolean;
  size?: "small" | "medium";
  readOnly?: boolean;
  loading?: boolean;
};

export default function Select<T extends string>(props: SelectProps<T>) {
  return (
    <FormControl
      size={props.size}
      variant="outlined"
      sx={{ width: "100%", ...props.sx }}
    >
      <InputLabel>{props.label}</InputLabel>
      <MuiSelect
        readOnly={props.readOnly}
        label={props.label}
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={(event) =>
          props.onChange && props.onChange(event.target.value as T)
        }
      >
        {props.loading && (
          <MenuItem disabled>
            <em>Loading</em>
          </MenuItem>
        )}
        {!props.loading &&
          (props.hideNone === undefined || props.hideNone === false) && (
            <MenuItem value={""}>
              <em>{props.noneLabel ?? "None"}</em>
            </MenuItem>
          )}
        {props.options &&
          props.options.map((option, index) => (
            <MenuItem key={index} value={option.id || ""}>
              {option.name}
            </MenuItem>
          ))}
      </MuiSelect>
    </FormControl>
  );
}
